/**
 * Created by dv on 7/11/2017.
 */
import {
  EditZmCollectionMessage,
  EditZmCollectionQuery,
  ZmCollection,
  SimpleResponse
} from "../../../autogenerated/ZoomBridge";

import {Logger} from './../../../logger/Logger';


export default class EditCollection {
  /**
   *
   * @param collectionId{number}
   */
  constructor(collectionId) {
    /**
     * @private
     * @type {Logger}
     * @const
     */
    this.logger = new Logger("EditCollection");

    /**
     * @private
     * @type {ZmCollection}
     */
    this.collection = new ZmCollection();
    if (collectionId > 0) {
      this.collection.setCollectionId(collectionId);
    } else {
      throw new Error("Collection id can't be less than or equal to zero.")
    }
  }

  /**
   * Updates the collection name
   * @param name{String}
   * @return {EditCollection}
   * @public
   */
  setName(name) {
    if (this.collection) {
      this.collection.setName(name);
    }
    return this;
  }

  /**
   * resp{SimpleResponse} will be used as input to onSuccess
   * @return {Promise.<Boolean,ErrorId>}
   */
  run() {
    let editZmCollectionMessage = new EditZmCollectionMessage();
    editZmCollectionMessage.setZmCollection(this.collection);
    /**
     * @type {EditZmCollectionQuery}
     */
    const query = new EditZmCollectionQuery();
    query.message = editZmCollectionMessage;
    return query.run(true);
  }
}
